import axios from 'axios';

/**
 * ContactForm Module
 * to handle the contact-form
 */
export default class {
  /**
   * constructor
   *   initializes
   *   eventListeners
   *   for all forms
   */
  constructor() {
    this.caller = document.querySelector('#kontaktformular');

    if (this.caller) {
      this.formElements = document.querySelectorAll('form[data-axios-form]');
      this.axiosResponseContainerSelector = '[data-axios-form-response-container]';
      this.axiosResponseContainerActiveClass = 'contact-form__response-container--show';

      this.formElements.forEach((form) => {
        form.addEventListener('submit', (event) => this.submitHandler(event));
      });
    }
  }

  /**
   * @function submitHandler
   * @desc handles the api post
   *       and form reset
   * @param {submit} event
   */
  submitHandler(event) {
    event.preventDefault();

    const form = event.target;
    const responseContainer = form.querySelector(this.axiosResponseContainerSelector);
    const responseSnippetClass = responseContainer.dataset.axiosFormResponseSnippetSelector;
    const responseSnippet = form.querySelector(responseSnippetClass);
    const method = form.getAttribute('method');
    const url = form.getAttribute('action');
    const data = new FormData(form);

    responseSnippet.innerText = responseContainer.dataset.axiosFormResponseMessageProgress;
    responseContainer.classList.add(this.axiosResponseContainerActiveClass);

    axios({
      method,
      url,
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(() => {
        responseSnippet.innerText = responseContainer.dataset.axiosFormResponseMessageSuccess;
        form.reset();
      })
      .catch((error) => {
        responseSnippet.innerText = responseContainer.dataset.axiosFormResponseMessageFailure;
      })
      .finally(() => {
        form.querySelector('[type=submit]').disabled = false; // eslint-disable-line no-param-reassign
      });
  }
}
